export const IMAGE_TYPE = 1
export const AUDIO_TYPE = 2
export const VIDEO_TYPE = 3
export const UPLOAD_DOMAIN = process.env.REACT_APP_API_UPLOAD.trim()
export const API_VIETLOOK = process.env.REACT_APP_API_VIETLOOK.trim()